/**
 * The type of (redux) action which sets the preferred maximum video height that
 * should be sent to and received from remote participants.
 *
 * {
 *     type: SET_PREFERRED_VIDEO_QUALITY,
 *     preferredVideoQuality: number,
 *     userInitiated: boolean
 * }.
 *
 * `userInitiated` separates a deliberate pick from the quality slider from the defaults the app sets for itself -
 * React Native applies STANDARD on CONFERENCE_JOINED, and SET_CONFIG applies AUTO or the persisted value. Only a
 * deliberate pick may override the participant-count cap; treating the automatic ones the same way pinned mobile
 * at a fixed quality and disabled the adaptive downgrade entirely.
 */
export const SET_PREFERRED_VIDEO_QUALITY = 'SET_PREFERRED_VIDEO_QUALITY';


/**
 * The type of (redux) action which sets the maximum video height that should be
 * received from remote participants, even if the user prefers a larger video
 * height.
 *
 * {
 *     type: SET_MAX_RECEIVER_VIDEO_QUALITY,
 *     maxReceiverVideoQuality: number
 * }.
 */
export const SET_MAX_RECEIVER_VIDEO_QUALITY = 'SET_MAX_RECEIVER_VIDEO_QUALITY';
